// extracted by mini-css-extract-plugin
module.exports = {"container":"SavingTranslationError_container__2R-Qd"};